import { useEffect } from "react";
import { DataSet } from "vis-data";
import { useAppSelector } from "@/app/appStore";

export function useTimelineSchedules({
  dataset,
}: {
  dataset: DataSet<any, any>;
}) {
  const visibleSchedules = useAppSelector(
    (state) => state.planogram.visibleSchedules
  );

  useEffect(() => {
    const currentSchedules = dataset
      .getIds()
      .filter((id) => id.toString().startsWith("schedule-"));

    dataset.remove(currentSchedules);

    const schedules = visibleSchedules.map((schedule) => {
      return {
        id: `schedule-${schedule.id}`,
        start: new Date(schedule.from_datetime),
        content: `Planogram ID: ${schedule.id}`,
        type: "point",
      };
    });

    dataset.add(schedules);
  }, [visibleSchedules, dataset]);
}
